import { createFileRoute } from '@tanstack/react-router';
import DetailReportExpired from '@/featured/dashboard/report/detail-report-expired';
import ReportNavTabs from '@/featured/dashboard/report/ReportNavTabs';

export default function ReportExpired() {
  return (
    <div className="w-full">
      <ReportNavTabs />
      <DetailReportExpired />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/report/expired')({
  component: ReportExpired,
});
